<template>
    <div class="distrole">
        <!-- <div class="table-head">
            <span class="menu-box">
                <span class="level1-menu">一级菜单</span>
                <span class="childrenItem">二级页面</span>
            </span>
            <span>数据查看/操作权限</span>
        </div>
        <div v-for="(item,i) in attrs.roleDetail" :key="i">
            <div class="table-head table-tr" v-if="item.level1Menu!=='我的资料'">
                <span class="menu-box">
                    <span class="level1-menu"><el-checkbox @change="level1Checkbox(item)" v-model="item.isActive">{{item.level1Menu}}</el-checkbox></span>
                    <span class="childrenItem item-style">
                        <div v-for="(el,index) in item.level2Page" :key="index"><el-checkbox @change="level2Checkbox(item)" v-model="el.isActive">{{el.menuName}}</el-checkbox></div>
                    </span>
                </span>
                <span class="item-style">
                    <div v-for="(el,index) in item.level2Page" :key="index"><el-checkbox @change="level2Checkbox(item)" v-model="el.isActive">本人</el-checkbox></div>
                </span>
            </div>
        </div> -->
        <el-table
        :data="attrs.roleDetail"
        style="width: 100%">
        <el-table-column
          label="一级菜单"
          width="120">
          <template slot-scope="scope">
              <el-checkbox @change="handleLevel1Checkbox(scope.row)" v-model="scope.row.isActive">{{scope.row.title}}</el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          label="二级页面"
          width="120">
          <template slot-scope="scope">
              <div v-for="(item,i) in scope.row.menu" :key="i">
                <el-checkbox @change="handleLevel2Checkbox(scope.row)" v-model="item.isActive">{{item.title}}</el-checkbox>
              </div>
          </template>
        </el-table-column>
        <el-table-column
          label="数据查看">
          <template slot-scope="scope">
              <div class="levelflex" v-for="(item,i) in scope.row.view_power" :key="i">
                <el-checkbox :disabled="item.power==='本人'" @change="handleViewPowerCheckbox(scope.row)" v-model="item.isActive">{{item.power}}</el-checkbox>
              </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作权限">
          <template slot-scope="scope">
              <div class="levelflex" v-for="(item,i) in scope.row.handle_power" :key="i">
                <el-checkbox :disabled="item.power==='本人'" @change="handlePowerCheckbox(scope.row,item.isActive)" v-model="item.isActive">{{item.power}}</el-checkbox>
              </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
</template>

<script>
import Role from "@/api/RoleModule";
export default {
    data() {
        return {
            attrs:{},
            // datas:[
            //     {
            //         level1Menu:'我的资料',
            //         isActive:true,
            //         level2Page:[
            //             {
            //                 menuName:"个人中心",
            //                 isActive:true,//是否选中
            //             }
            //         ]
            //     },
            //     {
            //         level1Menu:'数据中心',
            //         isActive:true,
            //         level2Page:[
            //             {
            //                 menuName:"基础数据",
            //                 isActive:true,//是否选中
            //             }
            //         ]
            //     },
            //     {
            //         level1Menu:'职位管理',
            //         isActive:true,
            //         level2Page:[
            //             {
            //                 menuName:"职位列表",
            //                 isActive:true,
            //             }
            //         ]
            //     },
            //     {
            //         level1Menu:'简历管理',
            //         isActive:true,
            //         level2Page:[
            //             {
            //                 menuName:"人才搜索",
            //                 isActive:true,
            //             },
            //             {
            //                 menuName:"简历列表",
            //                 isActive:true,
            //             },
            //         ]
            //     },
            //     {
            //         level1Menu:'权限与账号',
            //         isActive:true,
            //         level2Page:[
            //             {
            //                 menuName:"角色权限",
            //                 isActive:true,
            //             },
            //             {
            //                 menuName:"账号管理",
            //                 isActive:true,
            //             }
            //         ]
            //     }
            // ]
        };
    },
    props: {
        roleData: Object,
        dialogType:String
    },
    methods: {
        // level1Checkbox(item){
        //     item.level2Page.forEach(element => {
        //         element.isActive = item.isActive;
        //     });
        // },
        // level2Checkbox(item){
        //     var arr = [];
        //     item.level2Page.forEach(element => {
        //         if(!element.isActive){
        //             arr.push(1);
        //         }else{
        //             arr.pop(1);
        //         }
        //     });
        //     if(arr.length>=item.level2Page.length){
        //         item.isActive = false;
        //     }else{
        //         item.isActive = true;
        //     }
        // },
        //二级页面初始化
    level2(item){
      item.level2Page.forEach(element => {
          element.isActive = item.isActive;
      });
    },
    //数据查看初始化
    level3(item){
      item.level3Page.forEach(element => {
          element.isActive = item.isActive;
          let viewChild = element.viewChild||[];
          viewChild.forEach(e =>{
            e.isActive = item.isActive;
          })
      });
    },
    //操作权限初始化
    level4(item){
      item.level4Page.forEach(element => {
          element.isActive = item.isActive;
          let handleChild = element.handleChild||[];
          handleChild.forEach(e =>{
            e.isActive = item.isActive;
          })
      });
    },
    level1Checkbox(item){//一级
        this.level2(item);
        this.level3(item);
        this.level4(item);
    },
    level2Checkbox(scope){//二级
        for(var i=0;i<scope.level2Page.length;i++){
          if(scope.level2Page[i].isActive){
            scope.isActive = true;
            this.level3(scope);
            this.level4(scope);
            return;
          }
          scope.isActive = false;
          this.level3(scope);
          this.level4(scope);
        }
    },
    level3Checkbox(scope,item){//数据查看
      let viewChild = item.viewChild||[];
      viewChild.forEach(element => {
          element.isActive = item.isActive;
      });
      for(var i=0;i<scope.level3Page.length;i++){
        if(scope.level3Page[i].isActive){
          scope.isActive = true;
          this.level2(scope);
          this.level4(scope);
          return;
        }
        scope.isActive = false;
        this.level2(scope);
        this.level4(scope);
      }
    },
    level4Checkbox(scope,item){//操作权限
      let handleChild = item.handleChild||[];
      handleChild.forEach(element => {
          element.isActive = item.isActive;
      });
      for(var i=0;i<scope.level4Page.length;i++){
        if(scope.level4Page[i].isActive){
          scope.isActive = true;
          this.level2(scope);
          this.level3(scope);
          return;
        }
        scope.isActive = false;
        this.level2(scope);
        this.level3(scope);
      }
    },
    childCheckbox(scope,item,Child,arr){//数据查看/操作权限子菜单
      this.activefun(scope,item,arr);
      for(var i=0;i<Child.length;i++){
        if(!Child[i].isActive){
          item.isActive = false;
          return;
        }
        item.isActive = true;
      }
    },
    activefun(scope,item,arr){
      for(var i=0;i<item[arr[0]].length;i++){
        if(item[arr[0]][i].isActive){
          scope.isActive = true;
          this.level2(scope);
          this['level'+[arr[1]]](scope)
          return;
        }
        scope.isActive = false;
        this.level2(scope);
        this['level'+[arr[1]]](scope)
      }
    },
    handleLevel1Checkbox(scope){//一级菜单
      scope.menu.forEach(element => {
          element.isActive = scope.isActive;
      });
      scope.view_power.forEach(element => {
          element.isActive = scope.isActive;
      });
      scope.handle_power.forEach(element => {
          element.isActive = scope.isActive;
      });
    },
    handleLevel2Checkbox(scope){//二级菜单
      let item = scope.menu.find(item => {
          return item.isActive === true;
      });
      let view = scope.view_power.find(item => {
          return item.isActive === true;
      });
      let power = scope.handle_power.find(item => {
          return item.isActive === true;
      });
      console.log(!!item)
      scope.isActive = !!item;
      if(!!item&&!!view||!!item&&!!power){
          return
      }
      scope.handle_power.forEach(element => {
          element.isActive = !!item;
      });
      scope.view_power.forEach(element => {
          element.isActive = !!item;
      });
    },
    handleViewPowerCheckbox(scope){//操作查看
      let item = scope.view_power.find(item => {
          return item.isActive === true;
      });
      let menu = scope.menu.find(item => {
          return item.isActive === true;
      });
      let power = scope.handle_power.find(item => {
          return item.isActive === true;
      });
      console.log(!!item)
      scope.isActive = !!item;
      if(!!item&&!!menu||!!item&&!!power){
          return
      }
      scope.menu.forEach(element => {
          element.isActive = !!item;
      });
      scope.handle_power.forEach(element => {
          element.isActive = !!item;
      });
    },
    handlePowerCheckbox(scope,isActive){//操作权限
      if(isActive){
          scope.isActive = true;
          scope.menu.forEach(element => {
            element.isActive = true;
          });
          scope.view_power.forEach(element => {
            element.isActive = true;
          });
      }
      return
      let item = scope.handle_power.find(item => {
          return item.isActive === true;
      });
      console.log(!!item)
      if(!!item){
          scope.isActive = true;
          let menu = scope.menu.find(item => {
              return item.isActive === true;
          });
          if(!menu){
              scope.menu.forEach(element => {
                  element.isActive = true;
              });
          }
          let view = scope.view_power.find(item => {
              return item.isActive === true;
          });
          if(!view){
              scope.view_power.forEach(element => {
                  element.isActive = true;
              });
          }
      }
    },
        Submission(el){
            this.$emit('datamaseg',this.attrs,this.dialogType,true);
        },
    },
    mounted(){
        var that = this;
        Role.getRoleItem(this.roleData.id)//
        .then((res) => {
            var resData = res.data.data;
            resData.role_detail.forEach(element => {
              element.isActive=!!element.view_code?true:false;
                // element.level2Page.forEach(el => {
                //     element.level3Page = el.view||[{'viewName':'全部','isActive':true}];
                //     element.level4Page = el.handle||[{'handleName':'全部','isActive':true}];
                // })
            });
            that.attrs = {
                roleName:resData.role_name,
                roleDetail:resData.role_detail,
                id:resData.id,
                status:resData.active_status
            }
        }).catch((err) => {
            console.log(err)
        });
    }
}
</script>
<style scoped>
    .distrole{
        padding: 30px;
    }
    .distrole .table-head{
        background:#F4F9FF;
        border-radius:1px;
        padding: 17px 20px;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        font-size: 14px;
        color: #333333;
    }
    .distrole .table-tr{
        background:#fff;
        border-bottom: 1px solid #F5F5F5;
    }
    .distrole .menu-box{
        display: flex;
        display: -webkit-flex;
        align-items: center;
        -webkit-align-items: center;
    }
    .distrole .level1-menu{
        width: 80px;
        text-align: left;
    }
    .distrole .childrenItem{
        width: 200px;
        margin-left:120px;
        text-align: left;
    }
    .distrole .item-style div{
        margin-top: 15px;
    }
    .distrole .item-style div:first-child{
        margin-top: 0;
    }
    /* 分配权限弹窗 */
    .levelflex{
        display: flex;
        align-items: center;
    }
    .levelflex section{
        margin-left: 20px;
    }
    .distrole /deep/ .el-table th, .el-table tr{
        background: #f4f9ff;
        border-radius: 1px;
        font-size: 14px;
        color: #333;
        font-weight: normal;
    }
</style>


// WEBPACK FOOTER //
// src/views/role/components/distRole.vue